import { borderTypes, sizeVariantValues } from "@insite/mobius/FormField/formStyles";
import constants from "@store/constants";
import merge from "lodash/merge";

merge(sizeVariantValues, {
    default: {
        fontSize: 16, // Font size for label & field content (px)
        height: 45, // Height of the field (px)
        icon: 20, // Icon Size (px)
        iconPadding: 0, // Padding Around icon (px) - Not Needed
        descriptionLineSpacing: 8, // Spacing between the field and its label and hint & error (px)
        borderRadius: 4, // Border radius if the field is set to "rounded" (px)
        leftLabelPadding: 13, // Top spacing to align label vertically when labelPosition="left" (px)
        // Custom Code
        padding: 16, // Left and right padding for the field (px)
        lineHeight: 1.5, // Line height, mostly for textareas (number)
        descriptionFontSize: 14, // Font size for hint & error (px)
        descriptionLineHeight: 1.375, // Line height for hint & error (number)
    },
    small: {
        fontSize: 15,
        height: 40,
        icon: 17,
        iconPadding: 0,
        descriptionLineSpacing: 7,
        borderRadius: 3,
        leftLabelPadding: 10,
        // Custom Code
        padding: 13,
        lineHeight: 1.5,
        descriptionFontSize: 13,
        descriptionLineHeight: 1.375,
    },
    xsmall: {
        fontSize: 14,
        height: 32,
        icon: 15,
        iconPadding: 0,
        descriptionLineSpacing: 5,
        borderRadius: 3,
        leftLabelPadding: 7,
        // Custom Code
        padding: 9,
        lineHeight: 1.375,
        descriptionFontSize: 12,
        descriptionLineHeight: 1.375,
    },
});

merge(borderTypes, {
    inactive: {
        // Default State
        color: "colors.common.border", // border color (theme)
        width: constants.formField.borderWidth, // Border width (px)
        borderPaddingRule: "", // Input padding - Not needed (using sizeVariant "padding" property)
        textAreaBorderPaddingRule: "", // Text areas padding - Not needed (using sizeVariant "padding" property)
        underlinePaddingRule: "", // Input underline padding - Not needed
        textAreaUnderlinePaddingRule: "", // Text areas underline padding - Not needed
    },
    focus: {
        color: "focus.color",
        width: constants.formField.borderWidth,
        borderPaddingRule: "",
        textAreaBorderPaddingRule: "",
        underlinePaddingRule: "",
        textAreaUnderlinePaddingRule: "",
    },
    error: {
        color: "colors.danger.main",
        width: constants.formField.borderWidth,
        borderPaddingRule: "",
        textAreaBorderPaddingRule: "",
        underlinePaddingRule: "",
        textAreaUnderlinePaddingRule: "",
    },
});
